import {
  EDUCATIONLEVEL_LOADING,
  GET_EDUCATIONLEVEL,
  GET_EDUCATIONLEVEL_SUCCESS,
  GET_EDUCATIONLEVEL_FAIL,
  ADD_EDUCATIONLEVEL_SUCCESS,
  ADD_EDUCATIONLEVEL_FAIL,
  DELETE_EDUCATIONLEVEL_SUCCESS,
  DELETE_EDUCATIONLEVEL_FAIL,
  UPDATE_EDUCATIONLEVEL_SUCCESS,
  UPDATE_EDUCATIONLEVEL_FAIL,
  EDUCATIONLEVEL_RESET
} from "./actionType";

const INIT_STATE = {
  educationLevels: [],
  error: {},
};

const EducationLevel = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EDUCATIONLEVEL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EDUCATIONLEVEL:
          return {
            ...state,
            educationLevels: action.payload.data,
            isEducationLevelCreated: false,
            isEducationLevelSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EDUCATIONLEVEL_FAIL:
      switch (action.payload.actionType) {
        case GET_EDUCATIONLEVEL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEducationLevelCreated: false,
            isEducationLevelSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EDUCATIONLEVEL: {
      return {
        ...state,
        isEducationLevelCreated: false,
        loading: true,
      };
    }

    case EDUCATIONLEVEL_LOADING: {
      return {
        ...state,
        isEducationLevelCreated: false,
        loading: true,
      };
    }

    case ADD_EDUCATIONLEVEL_SUCCESS:
      return {
        ...state,
        isEducationLevelCreated: true,
        loading: false,
        educationLevels: [action.payload.data, ...state.educationLevels],
      };

    case ADD_EDUCATIONLEVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EDUCATIONLEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        educationLevels: state.educationLevels.filter(
          educationLevel => educationLevel.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EDUCATIONLEVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EDUCATIONLEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        educationLevels: state.educationLevels.map(educationLevel =>
          educationLevel.id.toString() === action.payload.data.id.toString() ? { ...educationLevel, ...action.payload.data } : educationLevel
        ),
      };

    case UPDATE_EDUCATIONLEVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EDUCATIONLEVEL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EducationLevel;